// Shows the success or error message only on the Escape Modern contact form
// that was submitted. Shopify marks every contact form on the page as posted,
// so the submitted form is found from the URL hash or remembered on submit.
(function () {
  var STORAGE_KEY = 'em-last-contact-form';

  function remember(id) {
    try {
      sessionStorage.setItem(STORAGE_KEY, id);
    } catch (e) {}
  }

  function recall() {
    try {
      var id = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
      return id;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form && form.classList && form.classList.contains('em-contact-form')) remember(form.id);
  });

  function init() {
    var forms = document.querySelectorAll('form.em-contact-form');
    if (!forms.length) return;

    var remembered = recall();
    var hash = window.location.hash.slice(1);
    var target = null;

    forms.forEach(function (form) {
      if (form.id === hash) target = form;
    });
    if (!target && remembered) target = document.getElementById(remembered);
    if (!target || !target.classList.contains('em-contact-form')) return;

    var status = target.querySelector('.em-inline-form__status');
    if (!status) return;

    var details = target.closest('details');
    if (details) details.open = true;
    status.hidden = false;
    status.focus();
    status.scrollIntoView({ block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();